import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

function authConfig() {
  const token = localStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
}

export async function searchCounterparties(q, { type, limit } = {}) {
  const res = await axios.get(`${API_URL}/api/finance/search`, {
    ...authConfig(),
    params: { q, type: type || undefined, limit: limit || undefined },
  });
  return res.data;
}

export async function getCounterparty(key) {
  const res = await axios.get(
    `${API_URL}/api/finance/search/counterparty/${encodeURIComponent(key)}`,
    authConfig()
  );
  return res.data;
}

export async function getCounterpartyEvents(key, { before, beforeKind, beforeId, limit } = {}) {
  // Composite keyset cursor (date + kind + id) — a date-only cursor silently drops
  // rows when one date holds more than a page of events.
  const res = await axios.get(
    `${API_URL}/api/finance/search/counterparty/${encodeURIComponent(key)}/events`,
    {
      ...authConfig(),
      params: {
        before: before || undefined,
        before_kind: beforeKind || undefined,
        before_id: beforeId || undefined,
        limit: limit || undefined,
      },
    }
  );
  return res.data;
}

export async function getUnmatchedPayees({ q, limit } = {}) {
  const res = await axios.get(`${API_URL}/api/finance/search/unmatched`, {
    ...authConfig(),
    params: { q: q || undefined, limit: limit || undefined },
  });
  return res.data;
}

export async function getUnmatchedPayeeTransactions(name, limit) {
  const res = await axios.get(`${API_URL}/api/finance/search/unmatched/transactions`, {
    ...authConfig(),
    params: { name, limit: limit || undefined },
  });
  return res.data;
}

export async function mapPayeeToCounterparty(payeeString, counterpartyKey) {
  const res = await axios.post(
    `${API_URL}/api/finance/search/alias`,
    { payee_string: payeeString, counterparty_key: counterpartyKey },
    authConfig()
  );
  return res.data;
}

export async function getProposals({ status, limit } = {}) {
  const res = await axios.get(`${API_URL}/api/finance/search/proposals`, {
    ...authConfig(),
    params: { status: status || undefined, limit: limit || undefined },
  });
  return res.data;
}

export async function confirmProposals(proposalIds) {
  const res = await axios.post(
    `${API_URL}/api/finance/search/proposals/confirm`,
    { proposal_ids: proposalIds },
    authConfig()
  );
  return res.data;
}

export async function rejectProposals(proposalIds, reason) {
  const res = await axios.post(
    `${API_URL}/api/finance/search/proposals/reject`,
    { proposal_ids: proposalIds, reason: reason || undefined },
    authConfig()
  );
  return res.data;
}

const financeSearchService = {
  searchCounterparties,
  getCounterparty,
  getCounterpartyEvents,
  getUnmatchedPayees,
  mapPayeeToCounterparty,
  getProposals,
  confirmProposals,
  rejectProposals,
};

export default financeSearchService;
